/**
 * Check if Ancillary Product is part of the SAVER program central site code we need to check.
 * @param {*} csSaverCode
 * @returns
 */
export const hasSaverProgramCSCode = csSaverCode => {
  // IPA - iProtect
  // AUD - Audit Protection - Protection Plus
  // AD3 - Audit Allies - Tax Pro Alliance
  const csSaverCodes = ['IPA', 'AUD', 'AD3'];
  let hasSaverCSCode = false;

  if (csSaverCodes.includes(csSaverCode)) {
    hasSaverCSCode = true;
  }
  return hasSaverCSCode;
};

/**
 * Check if the Account is in the SAVER program by having the SAVR custom tag.
 *
 * @param {*} customTags
 * @param {*} officeItem
 * @param {*} amount
 */
export const handleSaverProgramCalculation = (season, customTags, officeItem, amount) => {
  let markUpCheck = {
    pass: true,
    range: '',
  };
  let hasSaverProgram = false;

  // Remove the "$" sign and convert to int.
  amount = parseFloat(amount.replace(/[^\d.-]/g, ''));

  if (customTags.includes('SAVR')) {
    hasSaverProgram = true;
  }

  switch (officeItem.central_site_code) {
    // iProtect
    case 'IPA':
      markUpCheck = handleIProtectSaverCalc(markUpCheck, season, hasSaverProgram, amount);
      break;
    // Audit Allies - Tax Pro Alliance
    case 'AD3':
      markUpCheck = handleAuditAlliesSaverCalc(markUpCheck, season, hasSaverProgram, amount);
      break;
    // Audit Protection - Protection Plus
    case 'AUD':
      markUpCheck = handleProtectionPlusSaverCalc(markUpCheck, season, amount);
      break;
  }
  return markUpCheck;
};

/**
 * IPA: iProtect Markup Amount:
 *   - For season 2026
 *      - Default Saver cost:  $25.95
 *        - Max markup allowed: $0 up to $127.00
 *      - Default Non-Saver cost:  53.95
 *        - Max markup allowed: $0 up to $99.00
 */
const handleIProtectSaverCalc = (markUpCheck, season, hasSaverProgram, amount) => {
  if (season === 2026) {
    if (hasSaverProgram) {
      // Saver Program For season 2026
      if (amount < 0 || amount > 127) {
        markUpCheck.pass = false;
        markUpCheck.range = 'Markup range failed. Markup needs to be within $0 to $127.';
      }
    } else {
      // Non-Saver Program For season 2026
      if (amount < 0 || amount > 99) {
        markUpCheck.pass = false;
        markUpCheck.range = 'Markup range failed. Markup needs to be within $0 to $99.';
      }
    }
  }

  return markUpCheck;
};

/**
 * AD3: Audit Allies - Tax Pro Alliance Markup Amount:
 *   - For season 2026
 *      - Default Saver cost:  $25.95
 *        - Max markup allowed: $0 up to $99.00
 *      - Default Non-Saver cost:  59.95
 *        - Max markup allowed: $0 up to $65.00
 */
const handleAuditAlliesSaverCalc = (markUpCheck, season, hasSaverProgram, amount) => {
  if (season === 2026) {
    if (hasSaverProgram) {
      // Saver Program For season 2026
      if (amount < 0 || amount > 99) {
        markUpCheck.pass = false;
        markUpCheck.range = 'Markup range failed. Markup needs to be within $0 to $99.';
      }
    } else {
      // Non-Saver Program For season 2026
      if (amount < 0 || amount > 65) {
        markUpCheck.pass = false;
        markUpCheck.range = 'Markup range failed. Markup needs to be within $0 to $65.';
      }
    }
  }

  return markUpCheck;
};

/**
 * AUD: Audit Protection - Protection Plus Markup Amount:
 *   - For Season 2026
 *      - Default Saver and Non-Saver cost:  59.95
 *        - Max markup allowed: $0 up to $65.00
 */
const handleProtectionPlusSaverCalc = (markUpCheck, season, amount) => {
  // For season 2026
  if (season === 2026) {
    if (amount < 0 || amount > 65) {
      markUpCheck.pass = false;
      markUpCheck.range = 'Markup range failed. Markup needs to be within $0 to $65.';
    }
  }

  return markUpCheck;
};
